import React from "react";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export default function EmptyState({
  icon = <InboxOutlinedIcon style={{ fontSize: 48, color: "#94A3B8" }} />,

  title = "Nothing here yet",
  message = "",
  actionLabel,
  onAction,
}) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon" aria-hidden="true">{icon}</div>
      {title && <h3 className="empty-state-title">{title}</h3>}
      {message && <p className="empty-state-text">{message}</p>}
      {actionLabel && onAction && (
        <button type="button" className="btn outline empty-state-action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
